import { roundMoneyDiv } from '@/app/utils/moneyRounding';
import { formatTenThousandths, parseTenThousandths } from '@/shared/utils/moneyArithmetic';
import { twoPlaceMoney } from './twoPlaceMoney';

const RATE_ONE = 10000n;

const toNonNegativeTenThousandths = (decimal: string): bigint | null => {
    const parsed = parseTenThousandths(decimal);
    return parsed !== null && parsed >= 0n ? parsed : null;
};

type VatDirection = 'grossFromNet' | 'netFromGross';

export const deriveTenThousandths = (value: string, rate: string, direction: VatDirection): bigint | null => {
    const valueTenThousandths = toNonNegativeTenThousandths(value);
    const rateTenThousandths = toNonNegativeTenThousandths(rate || '0');
    if (valueTenThousandths === null || rateTenThousandths === null) return null;
    const multiplier = RATE_ONE + rateTenThousandths;
    return direction === 'grossFromNet'
        ? roundMoneyDiv(valueTenThousandths * multiplier, RATE_ONE)
        : roundMoneyDiv(valueTenThousandths * RATE_ONE, multiplier);
};

// Display convenience only: the server derives and stores the authoritative figure. The maths
// runs in integer ten-thousandths, so the preview matches it; padding past two places is trimmed.
export const deriveFromRate = (value: string, rate: string, direction: VatDirection): string => {
    const derived = deriveTenThousandths(value, rate, direction);
    return derived === null ? '' : (twoPlaceMoney(formatTenThousandths(derived)) ?? '');
};
